<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container child">
          <div class="modal-header"><h3>Sets</h3></div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 text-left">
                <input
                  id="label-filter"
                  v-model="filterSetName"
                  name="label-filter"
                  class="form-control form-control-sm"
                  placeholder="Search..."
                  @keyup="filterSets()">
              </div>
            </div>

            <div class="row bg-light">
              <div class="col-md-8 text-left text-bold p-2">
                Set Name
              </div>
              <div class="col-md-4 p-2"/>
            </div>
            <div
              class="container"
              style="height:240px;  overflow-y: scroll;">
              <div
                v-for="eachSet in filteredSets"
                :key="eachSet.id"
                class="row">
                <div class="col-md-6 text-left text-bold p-2">
                  {{ eachSet.name }}
                </div>
                <div class="col-md-6 p-2 text-right">
                  <button
                    type="button"
                    class="btn btn-sm btn-success"
                    @click.stop="loadSet(eachSet)">
                    Load Set
                  </button>
                  <button
                    v-if="userLoggedIn"
                    type="button"
                    class="btn btn-sm btn-outline-danger"
                    @click.stop="deleteSet(eachSet)">
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="modal-default-button btn btn-default"
              @click.stop="clearSet()">
              Clear Set
            </button>
            <button
              type="button"
              class="modal-default-button btn btn-default"
              @click="$emit('close')">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '../services/eventBus.js';
import { setsCollection, } from '../services/firebaseConfig';
import { mapGetters, } from 'vuex';

export default {
	data() {
		return {
			sets: [],
			filteredSets: [],
			filterSetName: '',
			hasErrors: false,
		};
	},
	computed: {
    ...mapGetters(['userLoggedIn',]),
	},
	created() {
		setsCollection
			.get()
			.then((querySnapShot) => {
				querySnapShot.forEach((doc) => {
					const data = {
						id: doc.id,
						name: doc.data().name,
						labels: doc.data().labels,
						languages: doc.data().languages,
					};
					this.sets.push(data);
				});
			})
			.then(() => {
				this.filteredSets = this.sets;
			});
	},
	methods: {
		filterSets() {
			this.filteredSets = this.sets.filter((set) => {
				return set.name
					.toLowerCase()
					.includes(this.filterSetName.toLowerCase());
			});
		},
		loadSet(set) {
			EventBus.$emit('loadSelectedSet', set);
		},
		clearSet() {
			EventBus.$emit('clearSet');
		},
		deleteSet(set) {
			setsCollection
				.doc(set.id)
				.delete()
				.then(() => {
					this.sets = this.sets.filter((item) => {
						return item.id !== set.id;
					});
					this.filterSets();
				})
				.catch((error) => {
					this.errorMessage = error;
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalSetList.vue